export default __webpack_public_path__ + "assets/images/9e056372dd3c029daf97d3fd07893c3d.png";